module.exports = __webpack_public_path__ + "img/07.be4fcd17.jpg";